import { useEffect, useState } from 'react';
import { useStyletron } from 'baseui';
import { Checkbox, LABEL_PLACEMENT, STYLE_TYPE } from 'baseui/checkbox';
import { TableBuilder, TableBuilderColumn } from 'baseui/table-semantic';
import { toaster } from 'baseui/toast';
import { StatusDisplay } from 'libs/platform-apps/src/components/StatusDisplay';
import { DateTime } from 'luxon';
import { getMatchQueue } from '@gtintel/platform-api';
import { useAsyncOp } from '@gtintel/platform-utils';
import { useMatching } from '../../context';
const ClickableRow = ({
  children,
  onClick
}) => <div onClick={onClick} style={{
  cursor: 'pointer'
}}>
    {children}
  </div>;
export function UnmatchedProjectsTable() {
  const [css] = useStyletron();
  const matchCtx = useMatching();
  const {
    isLoading,
    fn: getMatches
  } = useAsyncOp(getMatchQueue);
  const [rows, setRows] = useState([]);
  const [shouldHideProposed, setShouldHideProposed] = useState(true);
  const sortRows = rows => {
    return rows.sort((a, b) => a.match_requested_at > b.match_requested_at ? -1 : 1);
  };
  const filterRows = rows => {
    return rows.filter(row => {
      if (shouldHideProposed) {
        return !row.proposed_match;
      }
      return row.proposed_match;
    });
  };
  const sortAndFilterRows = rows => {
    return filterRows(sortRows(rows));
  };
  useEffect(() => {
    getMatches().then(data => {
      setRows(sortAndFilterRows(data));
    }).catch(error => {
      console.log(error);
      toaster.negative('Match Queue failed to load' + error);
    });
  }, [getMatches, shouldHideProposed]);
  const handleRowClick = row => {
    matchCtx.setMatchHintModal({
      isVisible: true,
      projectId: row.id
    });
  };
  return <TableBuilder data={rows} emptyMessage="No matches to display" isLoading={isLoading} loadingMessage="Loading...">
      <TableBuilderColumn header="Project Name">
        {row => <ClickableRow onClick={() => handleRowClick(row)}>
            <div className={css({
          width: '400px',
          display: 'flex'
        })}>
              <div className={css({
            padding: '4px 8px'
          })}>
                {row.name}
              </div>
              <StatusDisplay status={row.status} />
            </div>
          </ClickableRow>}
      </TableBuilderColumn>

      <TableBuilderColumn header="Client">
        {row => <ClickableRow onClick={() => handleRowClick(row)}>
            <div className={css({
          minWidth: '200px'
        })}>{row.client}</div>
          </ClickableRow>}
      </TableBuilderColumn>

      <TableBuilderColumn header={<div>
            <Checkbox checked={!shouldHideProposed} checkmarkType={STYLE_TYPE.toggle} onChange={e => setShouldHideProposed(!e.target.checked)} labelPlacement={LABEL_PLACEMENT.right}>
              Proposed Partner
            </Checkbox>
          </div>}>
        {row => <ClickableRow onClick={() => handleRowClick(row)}>
            <div className={css({
          minWidth: '200px'
        })}>
              {row.proposed_match?.name || `Requested ${DateTime.fromISO(row.match_requested_at).toRelative()}`}
            </div>
          </ClickableRow>}
      </TableBuilderColumn>
    </TableBuilder>;
}
export default UnmatchedProjectsTable;